/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router';

/**
 * HOC that injects React Router v7-compatible props (match, location, history)
 * into class components using React Router v7 hooks.
 *
 * Explicitly passed props take precedence over the injected ones.
 */
export function withRouterProps(Component) {
  function WithRouterProps(props) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const match = { params };
    const history = {
      push: navigate,
      replace: (path, state) => navigate(path, { replace: true, state }),
      go: (delta) => navigate(delta),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      location,
    };

    return <Component match={match} location={location} history={history} {...props} />;
  }

  WithRouterProps.displayName = `WithRouterProps(${Component.displayName || Component.name || 'Component'})`;
  return WithRouterProps;
}
